// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import Vuetify from 'vuetify'
import App from './App'
import AppStore from './store/plugin'
import VuexLoader from './components/VuexLoader'
import VuexBtn from './components/VuexBtn'
import VuexSnackbar from './components/VuexSnackbar'
import HelpDialog from './components/HelpDialog'
import RequestStatus from './components/ui/RequestStatus'
import VueAnalytics from 'vue-analytics'
import VueCookies from 'vue-cookies'

import GlobalMixin from './mixins/global'
import RequestsMixin from './mixins/requests'
import APIMixin from './mixins/api'
import HttpMixin from './mixins/http'
import PermissionsMixin from './mixins/permissions'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import {globalMessages} from './i18n/app'
import {helpMessages} from './i18n/help'

import router from './router'
// import vueKanban from 'vue-kanban'

// import './assets/vuetify.min.css'
import 'vuetify/dist/vuetify.min.css'
// import 'vue-multiselect/dist/vue-multiselect.min.css'
import './assets/style.css'

const isProd = process.env.NODE_ENV.startsWith('production')

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueCookies)

Vue.use(VueAnalytics, {
  id: process.env.GA_CODE,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

if (isProd) {
  Sentry.init({
    dsn: 'https://cca253c0b28c4c21a8f3e21aaac48996@sentry.io/116851',
    release: '3.1.5',
    integrations: [new Integrations.Vue({Vue, attachProps: true})]
  })
  console.log('sentry initted')
}

const messages = {
  en: {
    message: {
      hello: 'hello world'
    },
    global: globalMessages,
    help: helpMessages,
    buttons: {
      cancel: 'Cancel',
      close: 'Close',
      delete: 'Delete',
      save: 'Save',
      next: 'Next',
      back: 'Back',
      done: 'Done',
      edit: 'Edit'
    }
  },
  ja: {
    message: {
      hello: 'こんにちは、世界'
    }
  }
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages
})

Vue.use(AppStore)
// Vue.use(vueKanban)

Vue.mixin(GlobalMixin)
Vue.mixin(RequestsMixin)
Vue.mixin(APIMixin)
Vue.mixin(HttpMixin)
Vue.mixin(PermissionsMixin)
Vue.component('vuex-loader', VuexLoader)
Vue.component('vuex-btn', VuexBtn)
Vue.component('help-dialog', HelpDialog)
Vue.component('vuex-snackbar', VuexSnackbar)
Vue.component('request-status', RequestStatus)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

window.guruinstaller = null
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  // e.preventDefault();
  // Stash the event so it can be triggered later.
  window.guruinstaller = e
  // Update UI notify the user they can install the PWA
  // showInstallPromotion();
  // Optionally, send analytics event that PWA install promo was shown.
  console.log(`'beforeinstallprompt' event was fired.`)
})



// WEBPACK FOOTER //
// ./src/main.js